import React from 'react';
import TradeVisualizer from './components/TradeVisualizer';

function App() {
  return (
    <div className="">
      <TradeVisualizer />
    </div>
  );
}

export default App;